<template>
  <div v-loading.fullscreen.lock="config.loading.save" element-loading-text="Enviando mensagem de teste...">
    <ed-modal
      :title="'Enviar WhatsApp de Teste :: Conta '+(this.parent ? this.parent.formData.nome : '')"
      :modal="showFormEdit"
      :loadingSave="config.loading.save"
      :onSave="salvar"
      width="60%"
    >
      <div slot="modal-content" v-loading="config.loading.content">
        <ed-form :data="formData" :config="config" :response="response" :itens="formItems">
          <div slot="form-footer"></div>
        </ed-form>
      </div>
    </ed-modal>
  </div>
</template>

<script>
import Rest from 'common/rest';
import EdForm from 'common/form';
import EdModal from 'common/modal';
import FormItems from './_form/whatsapp-teste';

export default {
  name: 'conta-whatsapp-teste',
  components: { EdForm, EdModal },
  mixins: [Rest],
  props: {
    parent: {
      type: Object,
      default: null
    },
    showForm: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    showForm() {
      this.showFormEdit = !this.showFormEdit;
      this.init();
    }
  },
  data() {
    return {
      config: {
        hidden: {},
        click: {},
        loading: {
          save: false,
          content: false
        },
        list: {}
      },
      formData: {
        id: 0,
        telefone: null
      },
      response: {},
      formItems: [],
      showFormEdit: false
    };
  },
  mounted() {
    this.formItems = FormItems;
  },
  methods: {
    init() {
    },

    salvar() {
      this.response = {};
      this.config.loading.save = true;

      this.formData.id = this.parent.formData.id;

      this.post('/conta-whatsapp/testar', this.formData).then((result) => {
        result = result[0];
        this.config.loading.save = false;

        if (result.status == 200) {
          this.showFormEdit = !this.showFormEdit;
          this.edAlert('Mensagem de teste enviada com sucesso!');
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// teste.vue?afe11f0a